import { createRoot } from 'react-dom/client'
import App from './App'
// import { initSentry } from './utils/sentry'

import './styles/main.scss'

const container = document.getElementById('root')
const root = createRoot(container as HTMLElement)

// initSentry()

root.render(<App />)
